// API Action Types
export const FETCH_DATA_REQUEST = "FETCH_DATA_REQUEST";
export const FETCH_DATA_SUCCESS = "FETCH_DATA_SUCCESS";
export const FETCH_DATA_FAILURE = "FETCH_DATA_FAILURE";
export const CLEAR_DATA_REQUEST = "CLEAR_DATA_REQUEST";
export const SET_DATA = "SET_DATA";

// App & UI Action Types
export const SET_BREADCRUMBS = "SET_BREADCRUMBS";
export const SET_IS_GENERATED = "SET_IS_GENERATED";
export const SET_IS_GENERATING = "SET_IS_GENERATING";
export const SET_SIDEBAR_COLLAPSED = "SET_SIDEBAR_COLLAPSED";
export const SET_SELECTED_COUNTRY = "SET_SELECTED_COUNTRY";
export const SET_SELECTED_PRODUCT = "SET_SELECTED_PRODUCT";
export const SET_SELECTED_LANGUAGE = "SET_SELECTED_LANGUAGE";